import axios from "axios";
import Toaster from "v-toaster";
import Vue from "vue";
import FileSaver from "file-saver";

Vue.use(Toaster, { timeout: 2000 });
export default {
	getAxiosClient() {
		return axios.create({
			// baseURL: "/",
			// baseURL: "https://app.dev.garbur.com",
			baseURL: "https://app.garbur.com",
			headers: { Authorization: "Bearer " + localStorage.getItem("user-token") || "" },
		});
	},
	get(url, request) {
		return this.getAxiosClient()
			.get(url, request)
			.then((response) => Promise.resolve(response.data))
			.catch((error) => {
				if (error.response) {
					console.log("Error Get 1", error.response.data);
					Vue.toaster.error(error.response.data.error);
					if (error.response.status === 401) {
						window.location = "/logout";
					}
					return Promise.reject(error.response.data);
				}
				if (error.request) {
					console.log("Error Get 2", error.request);
					Vue.toaster.error(error.request);
					return Promise.reject(error.request);
				}
				console.log("Error Get 3", error.message);
				Vue.toaster.error(error.message);
				return Promise.reject(error.message);
			});
	},
	async download(url) {
		const data = await this.getAxiosClient().get(url, { responseType: "blob" });
		const filenameRegex = /filename="(.*?)"/;
		const filename = data.headers["content-disposition"].match(filenameRegex);
		FileSaver.saveAs(data.data, filename[1]);
	},
	getNoAuth(url, request) {
		return axios
			.get(url)
			.then((response) => response.json())
			.then((response) => response)
			.catch((error) => {
				if (error.response) {
					console.log(error.response.data);
					Vue.toaster.error(error.response.data.error);
					return error.response.data;
				}
				if (error.request) {
					console.log(error.request);
					Vue.toaster.error(error.request);
					return error.request;
				}
				console.log("Error", error.message);
				Vue.toaster.error(error.message);
				return error.message;
			});
	},
	post(url, request) {
		return this.getAxiosClient()
			.post(url, request)
			.then((response) => Promise.resolve(response.data))
			.catch((error) => {
				if (error.response) {
					console.log("Error Post 1", error.response.data);
					Vue.toaster.error(error.response.data.error);
					return Promise.reject(error.response.data);
				}
				if (error.request) {
					console.log("Error Post 2", error.request);
					Vue.toaster.error(error.request);
					return Promise.reject(error.request);
				}
				console.log("Error Post 3", error.message);
				Vue.toaster.error(error.message);
				return Promise.reject(error.message);
			});
	},
	patch(url, request) {
		return this.getAxiosClient()
			.patch(url, request)
			.then((response) => Promise.resolve(response))
			.catch((error) => Promise.reject(error));
	},
	delete(url, request) {
		return this.getAxiosClient()
			.delete(url, request)
			.then((response) => Promise.resolve(response))
			.catch((error) => Promise.reject(error));
	},
};
